<template>
  <router-view />
  <Navigation />
  <modal
    v-if="showSuccessModal"
    @close="showSuccessModal = false"
    @generateURL="onGenerateURL"
  >
    <template #header>
      <div>Preview</div>
    </template>
    <template #body>
      <ByteArkPlayerContainer
        class="w-720"
        :options="previewOptions"
        @ready="onReady"
      />
      <div class="information">
        <svg
          class="check-icon"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_56_18151)">
            <path
              d="M14.4541 8.1334C14.4541 11.7716 11.5047 14.7209 7.86655 14.7209C4.22837 14.7209 1.27905 11.7716 1.27905 8.1334C1.27905 4.49521 4.22837 1.5459 7.86655 1.5459C11.5047 1.5459 14.4541 4.49521 14.4541 8.1334ZM7.10458 11.6214L11.9921 6.73393C12.158 6.56796 12.158 6.29886 11.9921 6.1329L11.3911 5.53187C11.2251 5.36588 10.956 5.36588 10.79 5.53187L6.80405 9.51778L4.94311 7.65684C4.77715 7.49088 4.50804 7.49088 4.34205 7.65684L3.74102 8.25787C3.57506 8.42383 3.57506 8.69294 3.74102 8.8589L6.50353 11.6214C6.66951 11.7874 6.93859 11.7874 7.10458 11.6214Z"
              fill="#3FB772"
            />
          </g>
          <defs>
            <clipPath id="clip0_56_18151">
              <rect
                width="13.6"
                height="13.6"
                fill="white"
                transform="translate(1.06665 1.3335)"
              />
            </clipPath>
          </defs>
        </svg>

        <strong> Congratulation? </strong>
        - The player works great with all of your configuration. <br />
        Want to share this configuration with your team? Click
        <strong>&apos;Generate Playground URL&apos;</strong> and enjoy!
      </div>
    </template>
  </modal>
  <modal
    v-if="showInvalidModal"
    @close="showInvalidModal = false"
    :isGenerateURLBtnDisabled="false"
  >
    <template #header>
      <div>Preview</div>
    </template>
    <template #body>
      <div>
        <ByteArkPlayerContainer
          class="w-720"
          :options="previewOptions"
          @ready="onReady"
        />
      </div>
      <div class="invalid-information">
        <svg
          width="16"
          height="14"
          viewBox="0 0 16 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_231_347)">
            <path
              d="M15.0343 11.8296C15.5043 12.6461 14.9144 13.6668 13.9756 13.6668H1.75632C0.815794 13.6668 0.228567 12.6445 0.697646 11.8296L6.80738 1.21221C7.27761 0.395319 8.45534 0.396799 8.92473 1.21221L15.0343 11.8296ZM7.86605 9.63447C7.21917 9.63447 6.69476 10.1601 6.69476 10.8084C6.69476 11.4568 7.21917 11.9824 7.86605 11.9824C8.51294 11.9824 9.03735 11.4568 9.03735 10.8084C9.03735 10.1601 8.51294 9.63447 7.86605 9.63447ZM6.75401 5.41471L6.94289 8.88554C6.95173 9.04795 7.08572 9.1751 7.24799 9.1751H8.48412C8.64639 9.1751 8.78038 9.04795 8.78921 8.88554L8.9781 5.41471C8.98765 5.23927 8.84829 5.09176 8.673 5.09176H7.05908C6.8838 5.09176 6.74446 5.23927 6.75401 5.41471Z"
              fill="#EB5757"
            />
          </g>
          <defs>
            <clipPath id="clip0_231_347">
              <rect
                width="14.6667"
                height="13.0667"
                fill="white"
                transform="translate(0.533203 0.600098)"
              />
            </clipPath>
          </defs>
        </svg>

        <strong> Invalid Input </strong>
        - Some configuration are invalid. You can see a list of the invalid
        field below or close modal to fix them.
      </div>
      <table class="invalid-fields">
        <tr>
          <th>Name</th>
          <th>Input</th>
        </tr>
        <template v-for="(err, i) in errors" :key="i">
          <tr>
            <td class="name">{{ err.field }}</td>
            <td class="input">{{ err.input }}</td>
          </tr>
        </template>
      </table>
    </template>
  </modal>
  <!-- <button id="show-modal" @click="show404Modal = true">Show Modal</button> -->
  <modal
    v-if="show404Modal"
    @close="show404Modal = false"
    :hasButtonGroup="false"
  >
    <template #header>
      <div>Preview</div>
    </template>
    <template #body>
      <div class="image-error">
        <svg
          width="904"
          height="600"
          viewBox="0 0 904 600"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_58_13793)">
            <path
              d="M457.747 168.636C449.69 155.311 440.143 141.083 425.192 136.732C407.877 131.694 390.091 141.703 375.004 151.581C329.885 181.121 286.435 213.135 244.852 247.475L244.897 247.992C277.271 245.76 309.645 243.527 342.019 241.295C365.409 239.682 389.602 237.846 410.273 226.781C418.116 222.583 425.762 216.974 434.65 216.583C445.693 216.098 455.322 223.81 462.888 231.867C507.648 279.53 520.601 352.418 570.817 394.294C539.152 316.204 501.344 240.748 457.747 168.636Z"
              fill="#F2F2F2"
            />
            <path
              d="M732.878 572.904C727.928 566.654 725.906 565.191 721.023 558.883C681.269 507.466 643.903 454.312 608.925 399.422C585.167 362.143 562.587 324.148 541.185 285.437C530.996 267.033 521.086 248.485 511.456 229.792C503.983 215.299 496.677 200.718 489.537 186.051C487.495 181.862 485.511 177.653 483.537 173.435C478.886 163.516 474.321 153.548 469.419 143.764C463.834 132.612 457.035 120.921 446.778 113.428C442.11 109.878 436.529 107.731 430.685 107.236C422.336 106.696 414.632 110.144 407.389 113.91C354.403 141.539 304.797 176.18 259.929 215.597C214.946 255.103 174.739 299.735 140.126 348.583C139.067 350.095 136.563 348.651 137.632 347.129C141.841 341.178 146.133 335.29 150.508 329.467C204.913 257.11 271.622 194.887 347.585 145.642C360.365 137.36 373.385 129.466 386.646 121.961C393.329 118.176 400.042 114.439 406.869 110.934C413.563 107.496 420.67 104.404 428.316 104.289C454.338 103.884 467.811 133.353 477.066 153.182C479.974 159.423 482.918 165.644 485.897 171.846C497.154 195.392 508.846 218.724 520.97 241.84C528.453 256.112 536.1 270.301 543.91 284.406C568.217 328.331 594.052 371.366 621.416 413.512C657.665 469.339 693.625 518.656 734.92 570.863C736.056 572.307 734.024 574.368 732.878 572.904Z"
              fill="#E4E4E4"
            />
            <path
              d="M257.357 201.045C255.845 199.36 254.343 197.675 252.821 195.989C240.822 182.719 227.946 169.602 211.468 161.994C203.612 158.252 195.035 156.264 186.333 156.168C177.338 156.197 168.546 158.556 160.235 161.859C156.306 163.429 152.463 165.211 148.678 167.108C144.354 169.284 140.107 171.605 135.88 173.945C127.944 178.337 120.111 182.921 112.381 187.698C97.0015 197.203 82.1032 207.434 67.6866 218.39C60.2131 224.072 52.8939 229.94 45.729 235.994C39.0648 241.618 32.5354 247.393 26.1409 253.319C24.7734 254.581 22.7317 252.539 24.0991 251.278C25.7844 249.708 27.489 248.148 29.1936 246.607C34.0088 242.254 38.9012 237.984 43.8706 233.798C52.9325 226.152 62.229 218.801 71.7602 211.745C86.5816 200.766 101.913 190.532 117.755 181.043C125.671 176.305 133.697 171.766 141.831 167.426C144.287 166.116 146.772 164.835 149.285 163.622C154.988 160.745 160.914 158.333 167.005 156.408C175.633 153.617 184.762 152.721 193.768 153.779C202.464 155.044 210.842 157.943 218.46 162.322C234.639 171.364 247.187 185.348 259.399 198.994C260.632 200.381 258.6 202.432 257.357 201.045Z"
              fill="#E4E4E4"
            />
            <path
              d="M588.858 338.565L627.627 324.385L646.876 317.345C653.145 315.052 659.399 312.442 665.88 310.8C671.512 309.191 677.492 309.267 683.081 311.019C688.065 312.864 692.627 315.692 696.497 319.336C700.45 322.976 704.128 326.904 707.501 331.087C711.692 336.124 715.82 341.213 719.968 346.285C737.085 367.219 754.091 388.244 770.984 409.359C787.877 430.475 804.658 451.68 821.325 472.974C838.033 494.321 854.626 515.757 871.104 537.283C873.123 539.919 875.139 542.558 877.155 545.197C878.268 546.655 880.778 545.218 879.649 543.739C863.049 521.997 846.334 500.345 829.503 478.781C812.63 457.166 795.641 435.642 778.536 414.21C761.43 392.778 744.209 371.44 726.873 350.194C722.554 344.901 718.228 339.614 713.894 334.333C710.239 329.878 706.625 325.375 702.616 321.228C695.256 313.617 686.062 306.891 675.056 306.709C668.585 306.601 662.323 308.655 656.311 310.83C649.829 313.174 643.363 315.563 636.89 317.931L597.85 332.21L588.09 335.779C586.358 336.413 587.107 339.206 588.858 338.565L588.858 338.565Z"
              fill="#E4E4E4"
            />
            <path
              d="M206.367 178.693C186.665 168.567 161.435 170.55 143.33 183.201C177.863 189.159 212.018 197.13 245.62 207.075C231.666 198.897 220.751 186.086 206.367 178.693Z"
              fill="#F2F2F2"
            />
            <path
              d="M143.136 183.166L139.344 186.249C140.626 185.17 141.96 184.158 143.33 183.201C143.266 183.19 143.201 183.177 143.136 183.166Z"
              fill="#F2F2F2"
            />
            <path
              d="M695.037 338.707C691.221 334.061 687.095 329.197 681.386 327.311L676.057 327.521C716.626 399.207 771.417 461.846 837.067 511.593C789.723 453.964 742.38 396.336 695.037 338.707Z"
              fill="#F2F2F2"
            />
            <path
              d="M363.635 300.385C366.102 309.345 371.658 317.144 379.321 322.402C382.283 324.419 385.789 326.354 386.802 329.792C387.335 331.984 387.007 334.296 385.884 336.253C384.764 338.184 383.401 339.964 381.828 341.549L381.685 342.087C374.333 337.73 367.338 332.219 363.277 324.699C359.216 317.18 358.649 307.325 363.636 300.385"
              fill="#F2F2F2"
            />
            <path
              d="M608.406 513.64C610.872 522.6 616.428 530.399 624.091 535.657C627.054 537.674 630.559 539.609 631.572 543.047C632.106 545.239 631.777 547.551 630.655 549.508C629.534 551.439 628.171 553.219 626.598 554.804L626.455 555.342C619.103 550.985 612.108 545.474 608.047 537.954C603.986 530.435 603.419 520.58 608.406 513.64"
              fill="#F2F2F2"
            />
            <path
              d="M119.916 498.933C122.382 507.893 127.938 515.692 135.601 520.95C138.564 522.967 142.069 524.902 143.083 528.34C143.616 530.532 143.287 532.844 142.165 534.801C141.045 536.732 139.681 538.512 138.109 540.097L137.965 540.635C130.613 536.278 123.619 530.767 119.558 523.247C115.496 515.728 114.93 505.873 119.916 498.933"
              fill="#F2F2F2"
            />
            <path
              d="M682.046 107.153C711.635 107.153 735.622 83.1657 735.622 53.5763C735.622 23.9869 711.635 0 682.046 0C652.457 0 628.47 23.9869 628.47 53.5763C628.47 83.1657 652.457 107.153 682.046 107.153Z"
              fill="#212D37"
            />
            <path
              d="M778.731 12.47C752.765 8.96032 723.121 22.9948 716.392 48.3173C714.696 43.815 711.612 39.9684 707.587 37.3332C703.562 34.698 698.803 33.4107 693.998 33.6573C689.193 33.9038 684.591 35.6715 680.856 38.7048C677.122 41.7382 674.449 45.8803 673.222 50.5326L676.195 52.6616C731.838 64.6945 789.437 64.4341 844.97 51.8985C826.908 32.9169 804.696 15.9797 778.731 12.47Z"
              fill="#F0F0F0"
            />
            <path
              d="M667.376 83.9051C641.411 80.3954 611.767 94.4299 605.037 119.752C603.341 115.25 600.258 111.403 596.232 108.768C592.207 106.133 587.448 104.846 582.643 105.092C577.838 105.339 573.236 107.107 569.502 110.14C565.767 113.173 563.094 117.315 561.868 121.968L564.84 124.097C620.484 136.13 678.083 135.869 733.615 123.334C715.554 104.352 693.341 87.4147 667.376 83.9051Z"
              fill="#F0F0F0"
            />
            <path
              d="M894.001 97.4125C893.893 97.4127 893.786 97.3961 893.684 97.3632C615.92 9.52105 371.111 21.008 214.651 46.1126C193.359 49.5278 172.01 53.4724 151.196 57.8376C145.883 58.9507 140.37 60.1438 134.812 61.3861C128.174 62.8645 121.624 64.3869 115.343 65.9093C112.631 66.5515 109.971 67.1989 107.365 67.8513C103.417 68.8259 99.4106 69.8416 95.1163 70.9577C90.3176 72.1949 85.442 73.4927 80.6219 74.8151C80.6043 74.8213 80.5863 74.8264 80.568 74.8305L80.5686 74.8315C75.1241 76.318 69.7084 77.8477 64.4712 79.3752C61.6367 80.1939 58.8996 81.0013 56.2779 81.7984C55.9851 81.8794 55.7255 81.9574 55.4624 82.0374L54.8991 82.2087C54.5729 82.3082 54.2508 82.4057 53.9286 82.498L53.9081 82.5042L53.9086 82.5052L53.0561 82.77C52.0395 83.0778 51.0474 83.3783 50.0718 83.6779C24.287 91.6265 10.1122 97.2812 9.97215 97.3366C9.84409 97.388 9.70719 97.4136 9.56924 97.412C9.4313 97.4104 9.29501 97.3816 9.16817 97.3274C9.04133 97.2731 8.9264 97.1945 8.82998 97.0958C8.73355 96.9971 8.6575 96.8804 8.60617 96.7524C8.55484 96.6243 8.52925 96.4874 8.53083 96.3495C8.53241 96.2115 8.56115 96.0752 8.6154 95.9484C8.66966 95.8216 8.74835 95.7066 8.84701 95.6102C8.94568 95.5138 9.06236 95.4377 9.19042 95.3864C9.33148 95.331 23.5755 89.6476 49.4542 81.6692C50.4334 81.3686 51.428 81.068 52.4478 80.7592L53.2397 80.513C53.2669 80.5027 53.2941 80.4945 53.3218 80.4863C53.6424 80.395 53.9625 80.2976 54.2877 80.1991L54.8519 80.0277C55.133 79.9426 55.41 79.8585 55.6937 79.7805C58.2974 78.9885 61.0437 78.1791 63.8855 77.3573C69.1247 75.8288 74.5455 74.2992 79.9941 72.8106C80.011 72.8044 80.0284 72.8003 80.0454 72.7952V72.7941C84.8824 71.4677 89.776 70.1648 94.59 68.9234C98.891 67.8062 102.905 66.7886 106.86 65.8119C109.477 65.1605 112.142 64.5118 114.853 63.8658C121.141 62.3413 127.704 60.8168 134.354 59.3354C139.921 58.092 145.443 56.8959 150.765 55.7817C171.611 51.4094 192.994 47.4587 214.318 44.0383C371.002 18.8977 616.162 7.39229 894.317 95.3607C894.556 95.4362 894.76 95.5948 894.892 95.8078C895.025 96.0208 895.077 96.2742 895.039 96.5221C895 96.77 894.875 96.996 894.684 97.1593C894.494 97.3227 894.251 97.4125 894.001 97.4125Z"
              fill="#CCCCCC"
            />
            <path
              d="M276.274 441.049C275.91 439.985 275.298 439.023 274.488 438.244C274.189 437.966 273.865 437.717 273.521 437.498C270.78 435.67 266.683 435.26 264.077 437.498C263.815 437.725 263.572 437.975 263.352 438.244C262.575 439.2 261.777 440.135 260.957 441.049C259.613 442.582 258.236 444.064 256.797 445.503C256.388 445.902 255.978 446.312 255.558 446.711C255.316 446.952 255.074 447.184 254.833 447.415C253.908 448.297 252.963 449.148 252.007 449.988C251.503 450.44 250.998 450.881 250.484 451.312C249.717 451.953 248.95 452.594 248.173 453.214C248.099 453.266 248.025 453.319 247.952 453.382C247.931 453.392 247.92 453.413 247.899 453.424C247.889 453.424 247.878 453.424 247.868 453.445C247.839 453.456 247.814 453.474 247.794 453.497C247.563 453.655 247.406 453.76 247.29 453.854C247.332 453.833 247.374 453.802 247.416 453.781C247.227 453.928 247.027 454.075 246.838 454.222C245 455.577 243.12 456.88 241.197 458.098C236.441 461.143 231.445 463.795 226.259 466.03C225.912 466.166 225.555 466.313 225.198 466.45C211.619 472.013 196.89 474.184 182.284 472.774C180.792 472.659 179.301 472.501 177.809 472.301C176.086 472.049 174.374 471.745 172.672 471.398C166.193 470.105 159.854 468.192 153.742 465.683C146.096 462.182 138.825 457.916 132.038 452.951C130.987 452.205 129.926 451.459 128.865 450.734C130.074 447.772 131.261 444.809 132.416 441.826C132.994 440.387 133.551 438.948 134.097 437.498C138.394 426.331 142.428 415.059 146.293 403.745C150.201 392.284 153.889 380.756 157.355 369.162C157.713 367.985 158.059 366.809 158.395 365.632C160.213 359.508 161.957 353.369 163.627 347.217C163.785 346.618 163.953 346.03 164.1 345.431C164.583 343.666 165.056 341.901 165.518 340.136C166.568 336.155 164.194 331.396 160.013 330.44C158 329.924 155.865 330.209 154.059 331.236C152.252 332.263 150.914 333.951 150.327 335.944C149.876 337.646 149.424 339.338 148.962 341.039C146.745 349.265 144.413 357.463 141.965 365.632C141.608 366.809 141.251 367.985 140.894 369.162C135.494 386.958 129.566 404.575 123.109 422.013C122.331 424.125 121.543 426.229 120.745 428.327C120.356 429.356 119.968 430.386 119.568 431.415C118.801 433.443 118.014 435.47 117.226 437.498C116.774 438.685 116.312 439.872 115.85 441.049C115.545 441.794 115.251 442.54 114.957 443.276C111.961 442.2 108.858 441.453 105.702 441.049L105.197 440.986C102.75 440.691 100.275 440.712 97.8332 441.049C94.1785 441.475 90.6621 442.699 87.5326 444.634C84.4031 446.569 81.7368 449.168 79.7223 452.247C74.7113 460.136 74.7744 471.419 81.8023 478.121C89.0404 485.023 99.9973 484.971 108.517 480.653C113.032 478.21 116.839 474.642 119.568 470.295C120.614 468.719 121.575 467.088 122.447 465.41C122.667 465.557 122.888 465.704 123.109 465.862C123.949 466.45 124.789 467.049 125.619 467.637C130.455 471.14 135.551 474.269 140.862 476.997C152.283 482.675 164.578 486.393 177.231 487.996C177.515 488.028 177.788 488.07 178.072 488.101C179.469 488.28 180.876 488.416 182.284 488.532C202.477 490.054 222.695 485.921 240.672 476.598C242.195 475.81 243.704 474.984 245.2 474.119C247.521 472.774 249.79 471.345 252.007 469.833C253.215 469.013 254.392 468.183 255.558 467.311C260.653 463.558 265.403 459.357 269.75 454.758C271.399 453.024 272.979 451.235 274.488 449.39C275.915 447.88 276.738 445.898 276.799 443.822C276.791 442.874 276.613 441.934 276.274 441.049ZM102.319 466.072C102.54 465.914 102.76 465.746 102.97 465.578C102.907 465.736 102.603 465.914 102.319 466.072H102.319ZM105.691 462.679C105.449 462.952 105.229 463.225 104.987 463.498C104.252 464.321 103.462 465.093 102.624 465.809C102.508 465.914 102.382 466.019 102.256 466.114C102.254 466.114 102.253 466.114 102.252 466.115C102.251 466.115 102.249 466.116 102.248 466.117C102.247 466.118 102.247 466.119 102.246 466.12C102.246 466.122 102.245 466.123 102.245 466.124C102.094 466.192 101.946 466.269 101.804 466.356C101.352 466.629 100.89 466.881 100.417 467.112C99.4919 467.453 98.5397 467.716 97.5706 467.9C96.8259 467.954 96.0785 467.961 95.333 467.921H95.312C94.7974 467.807 94.289 467.666 93.7887 467.501C93.5366 467.374 93.295 467.228 93.0534 467.08C92.9588 466.996 92.8747 466.912 92.8222 466.86C92.7196 466.766 92.6248 466.664 92.5387 466.555C92.5387 466.554 92.5384 466.552 92.5379 466.551C92.5374 466.55 92.5366 466.549 92.5357 466.548C92.5347 466.547 92.5335 466.546 92.5322 466.545C92.5309 466.545 92.5295 466.545 92.5282 466.545C92.4126 466.335 92.2865 466.124 92.171 465.914C92.165 465.909 92.1612 465.901 92.1605 465.893C92.0764 465.631 92.0029 465.358 91.9399 465.084C91.9171 464.605 91.9206 464.124 91.9504 463.645C92.0913 462.974 92.2809 462.314 92.5176 461.67C92.7303 461.214 92.9725 460.772 93.2425 460.347C93.2635 460.305 93.3686 460.136 93.4841 459.947C93.4946 459.937 93.4946 459.937 93.4946 459.926C93.6522 459.748 93.8098 459.559 93.9779 459.391C94.2615 459.075 94.5662 458.802 94.8708 458.519C95.4633 458.131 96.0771 457.777 96.7092 457.458C97.7121 457.101 98.7412 456.824 99.7872 456.628C101.33 456.505 102.88 456.519 104.42 456.67C105.879 456.923 107.318 457.277 108.727 457.731C107.873 459.388 106.9 460.982 105.817 462.5C105.775 462.563 105.733 462.626 105.691 462.679ZM94.0093 459.222C93.9168 459.371 93.8075 459.508 93.6837 459.632C93.767 459.477 93.8773 459.339 94.0093 459.222Z"
              fill="#212D37"
            />
            <path
              d="M244.695 333.759C244.601 337.058 244.506 340.356 244.412 343.655C244.212 350.977 244.006 358.303 243.792 365.632C243.571 373.878 243.34 382.121 243.099 390.361C242.983 394.616 242.864 398.87 242.741 403.125C242.416 414.586 242.094 426.044 241.775 437.498C241.743 438.685 241.701 439.861 241.67 441.048C241.512 446.732 241.355 452.415 241.197 458.098C241.019 464.265 240.843 470.431 240.672 476.598C240.546 481.22 240.416 485.846 240.283 490.475C239.338 524.018 238.392 557.561 237.447 591.104C237.407 593.181 236.564 595.162 235.095 596.631C233.626 598.1 231.645 598.943 229.568 598.983C227.484 598.966 225.489 598.131 224.015 596.657C222.541 595.183 221.706 593.189 221.689 591.104C222.214 572.237 222.747 553.37 223.286 534.502C223.759 517.442 224.238 500.382 224.725 483.321C224.883 477.701 225.04 472.077 225.198 466.45C225.439 457.983 225.678 449.516 225.912 441.048C225.944 439.861 225.986 438.685 226.017 437.498C226.038 436.458 226.07 435.428 226.101 434.388C226.563 417.948 227.026 401.504 227.488 385.056C227.677 378.585 227.859 372.11 228.034 365.632C228.244 358.247 228.454 350.865 228.664 343.487C228.759 340.241 228.843 337.005 228.938 333.759C228.978 331.682 229.82 329.701 231.29 328.232C232.759 326.763 234.739 325.92 236.817 325.88C238.901 325.897 240.895 326.733 242.369 328.207C243.843 329.681 244.679 331.675 244.695 333.759Z"
              fill="#212D37"
            />
            <path
              d="M676.907 335.946C668.645 367.23 658.771 398.066 647.323 428.33C644.164 436.677 640.933 445.009 637.478 453.239L638.273 451.357C636.731 455.278 634.762 459.016 632.401 462.505C632.24 462.73 632.077 462.953 631.91 463.174C632.727 462.13 632.882 461.924 632.376 462.555C632.109 462.871 631.845 463.188 631.569 463.496C630.834 464.319 630.045 465.092 629.207 465.81C628.996 465.991 628.781 466.167 628.564 466.34L629.549 465.574C629.435 465.844 628.632 466.202 628.382 466.354C627.573 466.843 626.728 467.271 625.856 467.635L627.738 466.84C626.308 467.416 624.817 467.825 623.293 468.06L625.388 467.778C623.891 467.985 622.374 468.001 620.873 467.826L622.967 468.108C621.739 467.939 620.537 467.615 619.39 467.145L621.272 467.939C620.66 467.672 620.071 467.357 619.509 466.997C619.224 466.812 618.348 466.148 619.493 467.023C620.684 467.933 619.646 467.101 619.401 466.86C619.197 466.658 619.013 466.439 618.813 466.234C617.886 465.284 619.86 467.87 619.23 466.758C618.893 466.201 618.585 465.627 618.307 465.039L619.102 466.921C618.74 466.025 618.483 465.09 618.337 464.136L618.618 466.23C618.468 465.043 618.467 463.841 618.615 462.653L618.334 464.748C618.526 463.422 618.877 462.124 619.379 460.882L618.584 462.764C618.934 461.928 619.348 461.121 619.822 460.349C620.04 459.95 620.296 459.573 620.587 459.224C620.639 459.24 619.254 460.813 619.989 460.019C620.181 459.811 620.361 459.593 620.555 459.387C620.866 459.057 621.2 458.755 621.528 458.443C622.625 457.399 619.992 459.458 621.258 458.631C622.176 458.028 623.142 457.501 624.146 457.056L622.264 457.851C623.946 457.16 625.71 456.687 627.512 456.443L625.417 456.725C627.674 456.465 629.954 456.492 632.204 456.805L630.11 456.523C632.959 456.955 635.744 457.739 638.4 458.856L636.518 458.061C642.18 460.492 647.194 464.101 652.2 467.64C657.035 471.141 662.129 474.269 667.439 476.996C678.861 482.675 691.156 486.395 703.81 487.999C721.958 490.222 740.374 487.852 757.368 481.106C774.362 474.361 789.39 463.455 801.073 449.391C802.498 447.879 803.319 445.896 803.381 443.819C803.366 441.733 802.538 439.734 801.073 438.248C798.182 435.595 792.722 434.846 789.93 438.248C787.285 441.478 784.441 444.54 781.414 447.416C780.001 448.756 778.551 450.056 777.063 451.313C776.213 452.032 775.351 452.736 774.478 453.426C774.064 453.753 772.777 454.622 774.754 453.219C774.301 453.54 773.866 453.891 773.419 454.222C766.803 459.099 759.634 463.177 752.06 466.371L753.942 465.576C745.815 468.985 737.28 471.324 728.55 472.533L730.644 472.252C721.664 473.433 712.567 473.42 703.59 472.212L705.684 472.493C696.709 471.261 687.932 468.87 679.572 465.381L681.454 466.175C673.386 462.606 665.73 458.171 658.619 452.948C654.919 450.208 651.016 447.752 646.945 445.601C642.202 443.178 637.066 441.617 631.778 440.991C621.862 439.824 611.758 443.686 606.307 452.252C601.29 460.136 601.355 471.418 608.38 478.122C615.616 485.026 626.573 484.968 635.1 480.649C643.313 476.489 648.245 467.848 651.714 459.7C659.521 441.363 666.432 422.602 672.872 403.746C679.242 385.091 685.02 366.247 690.204 347.214C690.846 344.857 691.478 342.497 692.102 340.135C693.153 336.155 690.777 331.395 686.599 330.443C684.585 329.925 682.449 330.209 680.641 331.236C678.832 332.262 677.494 333.951 676.907 335.946L676.907 335.946Z"
              fill="#212D37"
            />
            <path
              d="M755.52 333.759L752.684 434.391L749.863 534.499L748.268 591.105C748.285 593.189 749.121 595.182 750.595 596.656C752.069 598.13 754.062 598.966 756.146 598.983C758.223 598.943 760.204 598.1 761.673 596.631C763.142 595.162 763.985 593.182 764.025 591.105L766.861 490.472L769.682 390.364L771.278 333.759C771.26 331.675 770.424 329.681 768.95 328.207C767.477 326.733 765.483 325.898 763.399 325.88C761.322 325.92 759.341 326.763 757.872 328.232C756.403 329.701 755.56 331.682 755.52 333.759Z"
              fill="#212D37"
            />
            <path
              opacity="0.2"
              d="M482.808 563.008H485.254V451.61H542.328V449.17H485.254V402.165H529.33C528.683 401.343 528.018 400.532 527.335 399.731H485.254V368.685C484.445 368.34 483.63 368.008 482.808 367.694V399.731H434.85V359.953C434.028 359.991 433.219 360.047 432.403 360.116V399.731H394.143V370.053C393.322 370.417 392.512 370.799 391.709 371.201V399.731H359.547V402.165H391.709V449.17H359.547V451.61H391.709V563.008H394.143V451.61C399.168 451.609 404.144 452.598 408.786 454.52C413.428 456.443 417.647 459.261 421.199 462.814C424.752 466.367 427.571 470.585 429.493 475.227C431.415 479.87 432.404 484.845 432.403 489.87V563.008H434.85V451.61H482.808V563.008ZM394.143 449.17V402.165H432.403V449.17H394.143ZM434.85 449.17V402.165H435.81C441.982 402.165 448.094 403.382 453.796 405.744C459.498 408.106 464.68 411.569 469.044 415.934C473.408 420.299 476.87 425.48 479.231 431.183C481.593 436.885 482.808 442.997 482.808 449.17H434.85Z"
              fill="black"
            />
            <path
              d="M467.867 529.607C464.787 543.347 457.409 555.747 446.804 565.01C446.027 565.682 445.249 566.333 444.44 566.974C442.476 567.153 440.525 567.335 438.589 567.52C436.982 567.667 435.395 567.825 433.82 567.972L433.536 568.004L433.336 566.281L432.538 559.305C429.441 554.249 427.521 548.56 426.921 542.661C426.321 536.762 427.056 530.803 429.071 525.226C431.845 517.747 436.866 511.139 441.804 504.584C448.621 495.528 455.25 486.578 455.492 475.537C458.847 479.83 461.636 484.537 463.791 489.541C461.757 490.498 459.93 491.843 458.412 493.501C457.982 493.974 457.551 494.635 457.845 495.203C458.097 495.686 458.727 495.802 459.274 495.865C460.587 496.001 461.91 496.138 463.224 496.274C464.274 496.39 465.325 496.495 466.375 496.61C467.646 500.782 468.508 505.067 468.949 509.406C469.657 516.154 469.292 522.973 467.867 529.607Z"
              fill="#212D37"
            />
            <path
              d="M502.744 502.073C496.546 506.58 492.922 513.061 490.106 520.205C487.221 521.128 484.625 522.786 482.574 525.016C482.143 525.489 481.713 526.151 482.007 526.718C482.259 527.201 482.889 527.317 483.436 527.38C484.749 527.516 486.072 527.653 487.386 527.79C484.57 536.236 481.986 544.976 477.006 552.109C473.695 556.818 469.378 560.733 464.369 563.57C463.003 564.348 461.593 565.046 460.146 565.661C454.809 566.07 449.574 566.508 444.44 566.974C442.476 567.152 440.526 567.334 438.589 567.52C436.982 567.667 435.396 567.825 433.82 567.972C433.809 567.394 433.809 566.816 433.82 566.238C434.152 550.847 439.814 536.048 449.84 524.365C450.313 523.819 450.796 523.283 451.29 522.747C456.369 517.322 462.342 512.809 468.949 509.406C479.359 503.993 491.027 501.461 502.744 502.073Z"
              fill="#212D37"
            />
            <path
              d="M440.406 562.131L439.198 565.703L438.589 567.52C436.982 567.667 435.395 567.825 433.82 567.972L433.536 568.003C431.792 568.182 430.059 568.36 428.325 568.539C427.874 568.014 427.422 567.478 426.981 566.932C416.016 553.654 410.752 536.575 412.341 519.428C413.929 502.281 422.241 486.459 435.458 475.421C434.072 482.68 435.69 489.635 438.347 496.537C438.064 496.652 437.791 496.768 437.528 496.894C435.494 497.851 433.667 499.197 432.149 500.854C431.719 501.327 431.288 501.989 431.582 502.556C431.834 503.039 432.465 503.155 433.011 503.218C434.324 503.354 435.648 503.491 436.961 503.628C438.011 503.743 439.062 503.848 440.112 503.964C440.606 504.016 441.1 504.069 441.594 504.121C441.667 504.279 441.73 504.426 441.804 504.584C444.798 511.076 448.023 517.599 449.84 524.365C450.296 526.062 450.654 527.784 450.912 529.523C451.721 535.398 451.196 541.38 449.378 547.025C447.559 552.67 444.493 557.833 440.406 562.131Z"
              fill="#212D37"
            />
            <path
              d="M546.149 409.765C537.106 392.124 523.095 377.282 506.616 366.374C490.085 355.482 471.115 348.849 451.398 347.066C448.814 346.831 446.223 346.694 443.626 346.653C440.557 346.608 394.392 359.923 378.927 370.797C363.471 381.537 350.757 395.761 341.809 412.32C332.878 428.97 328.485 447.677 329.071 466.562C329.837 485.561 335.133 504.101 344.517 520.638C353.773 537.121 366.916 551.094 382.802 561.341C398.915 571.622 415.1 598.882 434.124 599.844C453.292 600.814 475.151 575.099 492.633 567.292C510.115 559.419 525.228 547.103 536.466 531.569C547.387 516.346 554.452 498.702 557.055 480.149C559.759 461.152 558.499 441.56 552.012 423.404C550.347 418.738 548.389 414.183 546.149 409.765C544.28 406.082 538.8 404.726 535.37 406.938C533.602 408.026 532.322 409.754 531.796 411.761C531.27 413.769 531.537 415.902 532.543 417.718C533.641 419.88 534.662 422.079 535.606 424.313L534.811 422.43C538.383 431.018 540.812 440.038 542.035 449.259L541.754 447.164C543.055 457.167 543.032 467.299 541.684 477.296L541.966 475.201C540.604 485.197 537.936 494.972 534.03 504.273L534.824 502.391C532.814 507.137 530.472 511.735 527.815 516.151C526.468 518.382 525.04 520.561 523.528 522.687C522.865 523.62 522.181 524.537 521.492 525.451C520.592 526.644 522.717 523.893 521.788 525.063C521.63 525.262 521.472 525.462 521.313 525.661C520.836 526.258 520.352 526.849 519.862 527.434C516.586 531.342 513.012 534.989 509.171 538.342C508.215 539.177 507.242 539.993 506.253 540.791C505.761 541.188 505.274 541.603 504.761 541.973C504.78 541.959 506.42 540.712 505.449 541.436C505.144 541.663 504.842 541.894 504.536 542.12C502.498 543.63 500.406 545.063 498.26 546.419C493.319 549.532 488.135 552.242 482.759 554.522L484.641 553.728C475.367 557.632 465.62 560.299 455.65 561.661L457.744 561.379C447.78 562.726 437.681 562.744 427.711 561.432L429.806 561.714C420.745 560.497 411.882 558.101 403.443 554.587L405.325 555.381C400.436 553.317 395.723 550.861 391.231 548.037C389.008 546.636 386.843 545.149 384.735 543.575C384.434 543.35 384.136 543.123 383.837 542.897C382.875 542.171 384.528 543.432 384.541 543.441C383.982 543.04 383.444 542.61 382.928 542.154C381.91 541.325 380.908 540.477 379.922 539.61C375.977 536.135 372.293 532.375 368.899 528.36C368.05 527.355 367.218 526.336 366.405 525.302C366.053 524.854 365.411 523.947 366.83 525.858C366.643 525.606 366.45 525.36 366.261 525.109C365.808 524.509 365.361 523.904 364.921 523.294C363.378 521.16 361.912 518.972 360.521 516.733C357.38 511.663 354.639 506.357 352.322 500.861L353.116 502.743C349.325 493.723 346.732 484.245 345.405 474.551L345.686 476.645C344.488 467.709 344.471 458.655 345.635 449.714L345.354 451.809C346.547 443.151 348.877 434.688 352.282 426.639L351.487 428.522C353.63 423.483 356.157 418.616 359.046 413.965C360.493 411.638 362.026 409.367 363.645 407.153C364.013 406.65 364.385 406.15 364.761 405.653C365.101 405.204 366.037 404.084 364.44 406.061C364.597 405.867 364.747 405.668 364.902 405.472C365.79 404.347 366.701 403.238 367.633 402.148C371.16 398.018 374.981 394.149 379.066 390.57C380.098 389.665 381.147 388.78 382.212 387.913C382.696 387.52 383.183 387.13 383.673 386.744C383.869 386.59 384.068 386.439 384.263 386.283C382.165 387.953 383.68 386.738 384.156 386.381C386.351 384.736 388.604 383.174 390.917 381.694C396.056 378.407 401.463 375.558 407.08 373.177L405.198 373.971C413.35 370.548 449.468 362.469 456.037 363.351L453.942 363.069C463.598 364.417 473.034 367.024 482.012 370.825L480.13 370.03C484.679 371.962 489.101 374.183 493.367 376.679C495.498 377.929 497.588 379.246 499.635 380.632C500.604 381.288 501.563 381.958 502.512 382.644C502.986 382.986 503.457 383.332 503.926 383.682C504.187 383.877 504.445 384.074 504.705 384.269C505.797 385.087 503.201 383.083 504.346 383.988C508.176 386.998 511.814 390.244 515.237 393.709C516.919 395.421 518.542 397.188 520.108 399.009C520.911 399.944 521.698 400.892 522.468 401.853C522.851 402.331 524.154 404.061 522.557 401.942C522.947 402.46 523.342 402.974 523.728 403.496C527.047 407.989 529.995 412.746 532.543 417.718C534.427 421.392 539.883 422.762 543.323 420.544C545.091 419.457 546.371 417.729 546.898 415.721C547.424 413.713 547.156 411.58 546.149 409.765Z"
              fill="#212D37"
            />
            <path
              d="M454.345 538.343C453.531 538.38 452.726 538.167 452.038 537.731C451.351 537.296 450.813 536.659 450.499 535.908C450.185 535.157 450.109 534.327 450.283 533.532C450.456 532.736 450.869 532.013 451.467 531.461C451.567 531.063 451.639 530.777 451.739 530.379C451.703 530.292 451.667 530.206 451.631 530.119C447.975 521.402 424.648 545.702 423.64 553.894C423.196 557.516 423.383 561.186 424.194 564.744C416.638 548.261 412.714 530.347 412.689 512.215C412.687 507.665 412.94 503.118 413.446 498.597C413.864 494.89 414.444 491.209 415.187 487.555C419.236 467.728 427.932 449.145 440.558 433.331C447.779 433.734 454.108 432.634 454.719 418.639C454.827 416.15 456.674 413.995 457.081 411.542C456.391 411.633 455.691 411.689 455.001 411.734C454.786 411.746 454.561 411.757 454.346 411.768L454.265 411.772C453.507 411.806 452.756 411.62 452.101 411.237C451.447 410.854 450.917 410.29 450.575 409.613C450.234 408.935 450.096 408.174 450.177 407.42C450.258 406.666 450.556 405.951 451.034 405.362C451.331 404.996 451.629 404.63 451.927 404.264C452.379 403.699 452.843 403.145 453.295 402.58C453.347 402.526 453.396 402.47 453.442 402.411C453.962 401.766 454.481 401.134 455.001 400.489C454.052 399.016 452.776 397.783 451.272 396.884C446.062 393.833 438.874 395.946 435.111 400.659C431.336 405.372 430.624 411.983 431.935 417.871C433.224 422.881 435.357 427.635 438.241 431.93C437.959 432.291 437.665 432.642 437.382 433.003C432.218 439.645 427.716 446.776 423.942 454.295C425.01 445.956 411.954 415.838 406.905 409.459C400.841 401.796 388.405 405.14 387.336 414.854C387.326 414.948 387.316 415.042 387.306 415.136C388.056 415.559 388.79 416.008 389.508 416.483C390.411 417.086 391.11 417.947 391.514 418.954C391.919 419.961 392.009 421.067 391.775 422.127C391.54 423.186 390.991 424.15 390.199 424.892C389.407 425.634 388.409 426.119 387.337 426.285L387.227 426.302C377.189 440.635 409.369 477.94 417.424 469.563C413.633 480.308 411.255 491.5 410.35 502.857C409.837 509.558 409.867 516.289 410.44 522.985L410.406 522.748C408.616 508.164 377.912 486.481 368.946 488.287C363.781 489.328 358.694 489.091 359.478 494.301C359.49 494.384 359.503 494.468 359.516 494.551C360.908 495.118 362.263 495.771 363.573 496.506C364.323 496.929 365.057 497.378 365.775 497.853C366.678 498.456 367.377 499.317 367.781 500.324C368.186 501.331 368.276 502.437 368.042 503.496C367.807 504.556 367.258 505.52 366.466 506.262C365.674 507.004 364.676 507.489 363.604 507.655L363.494 507.672C363.415 507.683 363.347 507.694 363.268 507.706C358.699 523.428 392.585 548.802 413.186 540.728H413.197C415.239 549.6 418.197 558.235 422.024 566.495H453.555C453.668 566.145 453.769 565.783 453.871 565.433C450.953 565.616 448.023 565.442 445.146 564.913C447.486 562.042 449.825 559.149 452.165 556.279C452.217 556.225 452.266 556.169 452.311 556.109C453.498 554.64 454.696 553.182 455.883 551.713L455.883 551.711C455.947 547.208 455.43 542.715 454.346 538.344L454.345 538.343ZM418.238 467.314L418.254 467.292L418.238 467.337V467.314ZM411.254 530.274L410.982 529.664C410.994 529.223 410.994 528.783 410.982 528.331C410.982 528.206 410.96 528.082 410.96 527.958C411.061 528.737 411.152 529.517 411.265 530.297L411.254 530.274Z"
              fill="#212D37"
            />
            <path
              d="M100.06 472.732C106.442 472.732 111.616 467.558 111.616 461.176C111.616 454.794 106.442 449.621 100.06 449.621C93.6783 449.621 88.5046 454.794 88.5046 461.176C88.5046 467.558 93.6783 472.732 100.06 472.732Z"
              fill="#212D37"
            />
            <path
              d="M238.728 598.794C245.11 598.794 250.284 593.62 250.284 587.238C250.284 580.856 245.11 575.683 238.728 575.683C232.346 575.683 227.173 580.856 227.173 587.238C227.173 593.62 232.346 598.794 238.728 598.794Z"
              fill="#212D37"
            />
            <path
              d="M765.037 598.794C771.419 598.794 776.593 593.62 776.593 587.238C776.593 580.856 771.419 575.683 765.037 575.683C758.655 575.683 753.481 580.856 753.481 587.238C753.481 593.62 758.655 598.794 765.037 598.794Z"
              fill="#212D37"
            />
            <path
              d="M793.401 451.722C799.783 451.722 804.956 446.548 804.956 440.166C804.956 433.784 799.783 428.61 793.401 428.61C787.019 428.61 781.845 433.784 781.845 440.166C781.845 446.548 787.019 451.722 793.401 451.722Z"
              fill="#212D37"
            />
            <path
              d="M759.784 344.569C766.166 344.569 771.34 339.396 771.34 333.014C771.34 326.632 766.166 321.458 759.784 321.458C753.402 321.458 748.229 326.632 748.229 333.014C748.229 339.396 753.402 344.569 759.784 344.569Z"
              fill="#212D37"
            />
            <path
              d="M277.597 440.166C277.591 443.118 276.449 445.954 274.409 448.087C272.369 450.221 269.587 451.489 266.639 451.628C263.691 451.768 260.801 450.768 258.569 448.837C256.337 446.905 254.933 444.19 254.647 441.252C254.362 438.314 255.216 435.379 257.035 433.053C258.853 430.728 261.496 429.191 264.416 428.76C267.336 428.329 270.31 429.037 272.722 430.738C275.135 432.438 276.801 435.002 277.377 437.897C277.525 438.644 277.599 439.404 277.597 440.166Z"
              fill="#212D37"
            />
            <path
              d="M508.711 378.186C515.093 378.186 520.267 373.012 520.267 366.63C520.267 360.248 515.093 355.074 508.711 355.074C502.329 355.074 497.155 360.248 497.155 366.63C497.155 373.012 502.329 378.186 508.711 378.186Z"
              fill="#212D37"
            />
            <path
              d="M394.205 366.63C394.198 369.582 393.056 372.418 391.017 374.551C388.977 376.685 386.195 377.952 383.246 378.092C380.298 378.231 377.409 377.232 375.177 375.301C372.944 373.369 371.54 370.654 371.255 367.716C370.969 364.778 371.824 361.843 373.642 359.517C375.46 357.192 378.103 355.655 381.023 355.224C383.943 354.793 386.917 355.501 389.33 357.202C391.742 358.902 393.409 361.466 393.984 364.361C394.132 365.108 394.206 365.868 394.205 366.63Z"
              fill="#212D37"
            />
            <path
              d="M245.032 333.014C245.025 335.965 243.883 338.801 241.843 340.935C239.804 343.069 237.022 344.336 234.073 344.476C231.125 344.615 228.235 343.616 226.003 341.684C223.771 339.753 222.367 337.037 222.081 334.1C221.796 331.162 222.65 328.226 224.469 325.901C226.287 323.576 228.93 322.039 231.85 321.608C234.77 321.177 237.744 321.885 240.157 323.585C242.569 325.286 244.236 327.849 244.811 330.744C244.959 331.492 245.033 332.252 245.032 333.014Z"
              fill="#212D37"
            />
            <path
              d="M629.52 476.934C635.902 476.934 641.076 471.76 641.076 465.378C641.076 458.996 635.902 453.823 629.52 453.823C623.138 453.823 617.965 458.996 617.965 465.378C617.965 471.76 623.138 476.934 629.52 476.934Z"
              fill="#212D37"
            />
            <path
              d="M447.781 371.883C457.064 371.883 464.589 364.357 464.589 355.074C464.589 345.791 457.064 338.266 447.781 338.266C438.498 338.266 430.973 345.791 430.973 355.074C430.973 364.357 438.498 371.883 447.781 371.883Z"
              fill="#212D37"
            />
            <path
              d="M902.331 599.677L1.25082 600C1.08656 600 0.923903 599.967 0.772146 599.905C0.620388 599.842 0.482507 599.75 0.366356 599.633C0.250206 599.517 0.15806 599.379 0.0951998 599.228C0.0323398 599.076 0 598.913 0 598.749C0 598.585 0.0323398 598.422 0.0951998 598.27C0.15806 598.119 0.250206 597.981 0.366356 597.865C0.482507 597.748 0.620388 597.656 0.772146 597.593C0.923903 597.53 1.08656 597.498 1.25082 597.498L902.331 597.175C902.662 597.176 902.979 597.308 903.213 597.543C903.447 597.777 903.578 598.095 903.578 598.426C903.578 598.757 903.447 599.075 903.213 599.309C902.979 599.544 902.662 599.676 902.331 599.677Z"
              fill="#CACACA"
            />
          </g>
          <defs>
            <clipPath id="clip0_58_13793">
              <rect width="903.582" height="600" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </div>
      <div class="information-error">
        <div class="title">Hmm, Something's wrong...</div>
        <div class="detail">
          We're not sure what went wrong.<br />
          You can go
          <router-link :to="'/'"> back to the configuration page </router-link>
          and try to preview again later.
        </div>
      </div>
    </template>
  </modal>
  <modal
    v-if="show500Modal"
    @close="show500Modal = false"
    :hasButtonGroup="false"
  >
    <template #header>
      <div>Preview</div>
    </template>
    <template #body>
      <div class="image-error">
        <svg
          width="962"
          height="600"
          viewBox="0 0 962 600"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_58_13830)">
            <path
              d="M251.167 365.665C352.142 365.665 433.999 283.808 433.999 182.833C433.999 81.8569 352.142 0 251.167 0C150.191 0 68.334 81.8569 68.334 182.833C68.334 283.808 150.191 365.665 251.167 365.665Z"
              fill="#F2F2F2"
            />
            <path
              d="M0 43.8989C0 110.421 41.7323 164.249 93.3053 164.249L0 43.8989Z"
              fill="#212D37"
            />
            <path
              d="M93.3054 164.249C93.3054 96.9803 139.876 42.5469 197.429 42.5469L93.3054 164.249Z"
              fill="#212D37"
            />
            <path
              d="M33.8064 49.9292C33.8064 113.118 60.4183 164.249 93.3055 164.249L33.8064 49.9292Z"
              fill="#212D37"
            />
            <path
              d="M93.3054 164.25C93.3054 78.2945 147.134 8.74072 213.656 8.74072L93.3054 164.25Z"
              fill="#212D37"
            />
            <path
              d="M73.6763 165.098C73.6763 165.098 86.9085 164.69 90.8964 161.851C94.8842 159.011 111.251 155.62 112.24 160.174C113.229 164.729 132.126 182.825 117.187 182.946C102.248 183.066 82.4747 180.619 78.4945 178.194C74.5144 175.77 73.6763 165.098 73.6763 165.098Z"
              fill="#A8A8A8"
            />
            <path
              opacity="0.2"
              d="M117.453 181.36C102.514 181.481 82.7414 179.033 78.7612 176.609C75.73 174.762 74.5222 168.137 74.118 165.081C73.8381 165.093 73.6763 165.098 73.6763 165.098C73.6763 165.098 74.5144 175.77 78.4946 178.194C82.4748 180.619 102.248 183.066 117.187 182.946C121.499 182.911 122.989 181.377 122.907 179.104C122.308 180.477 120.663 181.334 117.453 181.36Z"
              fill="black"
            />
            <path
              d="M170.48 386.215C259.13 386.215 330.995 376.438 330.995 364.378C330.995 352.318 259.13 342.541 170.48 342.541C81.8299 342.541 9.96484 352.318 9.96484 364.378C9.96484 376.438 81.8299 386.215 170.48 386.215Z"
              fill="#333D4D"
            />
            <path
              opacity="0.1"
              d="M170.48 382.711C244.908 382.711 305.244 374.503 305.244 364.378C305.244 354.252 244.908 346.044 170.48 346.044C96.0519 346.044 35.7161 354.252 35.7161 364.378C35.7161 374.503 96.0519 382.711 170.48 382.711Z"
              fill="black"
            />
            <path
              d="M718.119 600C852.28 600 961.038 585.204 961.038 566.953C961.038 548.702 852.28 533.906 718.119 533.906C583.959 533.906 475.201 548.702 475.201 566.953C475.201 585.204 583.959 600 718.119 600Z"
              fill="#333D4D"
            />
            <path
              d="M266.617 573.929C347.208 573.929 412.54 565.041 412.54 554.077C412.54 543.113 347.208 534.226 266.617 534.226C186.026 534.226 120.695 543.113 120.695 554.077C120.695 565.041 186.026 573.929 266.617 573.929Z"
              fill="#333D4D"
            />
            <path
              d="M397.089 537.339C474.343 557.082 622.84 511.588 639.149 460.086"
              stroke="#212D37"
              stroke-width="2"
              stroke-miterlimit="10"
            />
            <path
              d="M265.759 222.318C265.759 222.318 377.347 191.416 384.214 290.987C391.081 390.558 292.368 418.884 369.621 438.627"
              stroke="#212D37"
              stroke-width="2"
              stroke-miterlimit="10"
            />
            <path
              d="M157.95 461.187C157.95 461.187 191.488 451.9 193.552 481.826C195.616 511.753 165.947 520.267 189.166 526.2"
              stroke="#212D37"
              stroke-width="2"
              stroke-miterlimit="10"
            />
            <path
              d="M668.416 483.468L661.654 526.64C661.654 526.64 628.365 544.325 651.771 544.845C675.178 545.365 785.448 544.845 785.448 544.845C785.448 544.845 806.774 544.845 772.965 526.12L766.203 480.867L668.416 483.468Z"
              fill="#212D37"
            />
            <path
              opacity="0.1"
              d="M647.063 544.376C652.379 539.646 661.654 534.718 661.654 534.718L668.416 491.546L766.203 491.638L772.965 534.198C780.849 538.564 785.733 541.912 788.59 544.479C792.933 543.489 797.678 539.807 772.965 526.12L766.203 480.867L668.416 483.468L661.654 526.64C661.654 526.64 633.682 541.502 647.063 544.376Z"
              fill="black"
            />
            <path
              d="M921.58 182.565H511.999C503.444 182.565 496.509 189.5 496.509 198.055V473.96C496.509 482.514 503.444 489.449 511.999 489.449H921.58C930.135 489.449 937.07 482.514 937.07 473.96V198.055C937.07 189.5 930.135 182.565 921.58 182.565Z"
              fill="#212D37"
            />
            <path
              d="M922.246 198.95H511.333V428.853H922.246V198.95Z"
              fill="#333D4D"
            />
            <path
              d="M716.789 194.268C718.226 194.268 719.39 193.104 719.39 191.668C719.39 190.231 718.226 189.067 716.789 189.067C715.353 189.067 714.188 190.231 714.188 191.668C714.188 193.104 715.353 194.268 716.789 194.268Z"
              fill="#F2F2F2"
            />
            <path
              d="M937.07 447.058V473.959C937.07 475.994 936.669 478.008 935.891 479.887C935.113 481.767 933.972 483.475 932.533 484.913C931.095 486.351 929.387 487.492 927.508 488.271C925.628 489.049 923.614 489.449 921.58 489.449H511.999C509.965 489.449 507.95 489.049 506.071 488.271C504.191 487.492 502.484 486.351 501.045 484.913C499.607 483.475 498.466 481.767 497.688 479.887C496.909 478.008 496.509 475.994 496.509 473.959V447.058H937.07Z"
              fill="#212D37"
            />
            <path
              d="M831.741 572.932V578.134H551.904V573.973L552.289 572.932L559.186 554.207H826.019L831.741 572.932Z"
              fill="#212D37"
            />
            <path
              d="M939.431 567.84C938.921 570.019 936.997 572.319 932.648 574.493C917.044 582.295 885.315 572.412 885.315 572.412C885.315 572.412 860.869 568.251 860.869 557.328C861.555 556.858 862.271 556.432 863.012 556.054C869.572 552.583 891.324 544.018 929.894 556.416C932.735 557.308 935.273 558.971 937.225 561.221C938.788 563.05 940.013 565.371 939.431 567.84Z"
              fill="#212D37"
            />
            <path
              opacity="0.1"
              d="M939.431 567.84C920.331 575.158 903.307 575.705 885.836 563.57C877.024 557.453 869.019 555.939 863.012 556.054C869.572 552.583 891.325 544.018 929.894 556.416C932.735 557.308 935.273 558.971 937.225 561.221C938.788 563.05 940.014 565.371 939.431 567.84Z"
              fill="black"
            />
            <path
              d="M915.484 563.57C919.218 563.57 922.245 562.638 922.245 561.489C922.245 560.34 919.218 559.409 915.484 559.409C911.749 559.409 908.722 560.34 908.722 561.489C908.722 562.638 911.749 563.57 915.484 563.57Z"
              fill="#F2F2F2"
            />
            <path
              d="M716.789 478.266C722.247 478.266 726.672 473.842 726.672 468.384C726.672 462.926 722.247 458.501 716.789 458.501C711.331 458.501 706.906 462.926 706.906 468.384C706.906 473.842 711.331 478.266 716.789 478.266Z"
              fill="#F2F2F2"
            />
            <path
              opacity="0.1"
              d="M831.741 572.932V578.134H551.904V573.972L552.289 572.932H831.741Z"
              fill="black"
            />
            <path
              d="M271.768 136.48H93.2268V344.206H271.768V136.48Z"
              fill="#212D37"
            />
            <path
              d="M289.793 115.88H75.2009V189.7H289.793V115.88Z"
              fill="#333D4D"
            />
            <path
              d="M289.793 203.434H75.2009V277.253H289.793V203.434Z"
              fill="#333D4D"
            />
            <path
              d="M289.793 290.987H75.2009V364.807H289.793V290.987Z"
              fill="#333D4D"
            />
            <path
              opacity="0.4"
              d="M246.875 128.755H233.141V142.489H246.875V128.755Z"
              fill="#E4E4E4"
            />
            <path
              opacity="0.8"
              d="M266.617 128.755H252.883V142.489H266.617V128.755Z"
              fill="#E4E4E4"
            />
            <path
              d="M286.36 128.755H272.626V142.489H286.36V128.755Z"
              fill="#E4E4E4"
            />
            <path
              opacity="0.4"
              d="M246.875 215.451H233.141V229.185H246.875V215.451Z"
              fill="#E4E4E4"
            />
            <path
              opacity="0.8"
              d="M266.617 215.451H252.883V229.185H266.617V215.451Z"
              fill="#E4E4E4"
            />
            <path
              d="M286.36 215.451H272.626V229.185H286.36V215.451Z"
              fill="#E4E4E4"
            />
            <path
              opacity="0.4"
              d="M246.875 302.146H233.141V315.88H246.875V302.146Z"
              fill="#E4E4E4"
            />
            <path
              opacity="0.8"
              d="M266.617 302.146H252.883V315.88H266.617V302.146Z"
              fill="#E4E4E4"
            />
            <path
              d="M286.36 302.146H272.626V315.88H286.36V302.146Z"
              fill="#E4E4E4"
            />
            <path
              d="M271.767 529.614C309.219 529.614 339.579 499.253 339.579 461.802C339.579 424.351 309.219 393.991 271.767 393.991C234.316 393.991 203.956 424.351 203.956 461.802C203.956 499.253 234.316 529.614 271.767 529.614Z"
              fill="#212D37"
            />
            <path
              d="M261.467 515.021H240.866V551.931H261.467V515.021Z"
              fill="#212D37"
            />
            <path
              d="M302.669 515.021H282.068V551.931H302.669V515.021Z"
              fill="#212D37"
            />
            <path
              d="M258.034 558.798C267.515 558.798 275.201 555.916 275.201 552.361C275.201 548.805 267.515 545.923 258.034 545.923C248.552 545.923 240.866 548.805 240.866 552.361C240.866 555.916 248.552 558.798 258.034 558.798Z"
              fill="#212D37"
            />
            <path
              d="M299.235 557.94C308.717 557.94 316.403 555.058 316.403 551.502C316.403 547.947 308.717 545.064 299.235 545.064C289.754 545.064 282.068 547.947 282.068 551.502C282.068 555.058 289.754 557.94 299.235 557.94Z"
              fill="#212D37"
            />
            <path
              d="M273.484 467.811C286.284 467.811 296.66 457.435 296.66 444.635C296.66 431.835 286.284 421.459 273.484 421.459C260.685 421.459 250.308 431.835 250.308 444.635C250.308 457.435 260.685 467.811 273.484 467.811Z"
              fill="white"
            />
            <path
              d="M273.484 452.36C277.751 452.36 281.209 448.902 281.209 444.635C281.209 440.368 277.751 436.91 273.484 436.91C269.218 436.91 265.759 440.368 265.759 444.635C265.759 448.902 269.218 452.36 273.484 452.36Z"
              fill="#333D4D"
            />
            <path
              d="M205.988 398.74C200.513 374.219 218.016 349.441 245.082 343.397C272.148 337.353 298.528 352.333 304.004 376.854C309.479 401.376 291.541 410.42 264.475 416.463C237.409 422.507 211.464 423.262 205.988 398.74Z"
              fill="#212D37"
            />
            <path
              d="M335.368 448.278C352.583 440.91 364.663 430.556 362.35 425.151C360.037 419.747 344.206 421.339 326.991 428.707C309.776 436.075 297.696 446.429 300.009 451.834C302.322 457.238 318.153 455.646 335.368 448.278Z"
              fill="#212D37"
            />
            <path
              d="M208.329 493.771C225.544 486.403 237.625 476.049 235.312 470.645C232.998 465.24 217.168 466.832 199.953 474.2C182.738 481.568 170.657 491.923 172.97 497.327C175.283 502.731 191.114 501.139 208.329 493.771Z"
              fill="#212D37"
            />
            <path
              d="M311.252 481.545C311.252 488.182 294.163 501.287 275.201 501.287C256.238 501.287 238.291 489.04 238.291 482.403C238.291 475.766 256.238 477.253 275.201 477.253C294.163 477.253 311.252 474.908 311.252 481.545Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_58_13830">
              <rect width="961.038" height="600" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </div>
      <div class="information-error">
        <div class="title">Oops! There was internal server error.</div>
        <div class="detail">
          Looks like our server failed to load your request but don't worry,
          we're working on it.<br />
          Please go
          <router-link :to="'/'"> back to the configuration page </router-link>
          and try again in a few minutes.
        </div>
      </div>
    </template>
  </modal>
  <main>
    <header id="title">
      <h1>Player Playground</h1>
    </header>
    <PlaygroundURL v-if="isReadyToGenerateURL" :playgroundURL="playgroundUrl" />
    <Preview
      :playerOptions="previewOptions"
      :key="componentKey"
      v-if="!showModal && previewOptions"
    />
    <TabList v-model="currentTab" />
    <ConfigForm
      v-show="currentTab === 1"
      :optionsProps="playerOptions"
      @newConfig="previewNewConfig"
      :key="componentKey"
      v-if="playerOptions"
    />
    <CodePreview v-show="currentTab === 2" :playerOptions="previewOptions" :key="componentKey" />
  </main>
</template>

<script>
import Modal from "../components/molecules/Modal.vue";
import Preview from "../components/organisms/PlayerPreview.vue";
import ConfigForm from "../components/organisms/ConfigForm.vue";
import TabList from "@/components/molecules/TabList.vue";
import Navigation from "../components/molecules/Navigation.vue";
import CodePreview from "../components/organisms/CodePreview.vue";
import ByteArkPlayerContainer from "@byteark/byteark-player-vue";
import PlaygroundURL from "@/components/molecules/PlaygroundURL.vue";
import { defaultOptions } from "@/utils/defaultOptions";
import { useRoute } from "vue-router";
import { computed } from "vue";
import axios from "axios";
import _ from "lodash";
export default {
  setup() {
    const params = useRoute().query;
    const configStr = computed(() => params.config);
    return {
      configStr,
    };
  },
  name: "App",
  components: {
    Modal,
    Navigation,
    Preview,
    TabList,
    ConfigForm,
    CodePreview,
    ByteArkPlayerContainer,
    PlaygroundURL,
  },
  data() {
    return {
      playerOptions: null,
      previewOptions: null,
      componentKey: 0,
      loading: false,
      error: false,
      currentTab: 1,
      isReadyToPreview: false,
      isReadyToGenerateURL: false,
      showModal: false,
      showSuccessModal: false,
      showInvalidModal: false,
      show404Modal: false,
      show500Modal: false,
      errorsFieldName: [],
      playgroundUrl: "",
    };
  },
  created() {
    this.$watch(
      () => this.$route.params,
      () => {
        this.getConfig();
      },
      { immediate: true }
    );
  },
  watch: {
    showModal(isReady) {
      const body = document.querySelector("body");
      if (isReady) {
        body.classList.add("stop-scrolling");
      } else {
        body.classList.remove("stop-scrolling");
      }
    },
    showSuccessModal(isShow) {
      this.showModal = isShow;
    },
    showInvalidModal(isShow) {
      this.showModal = isShow;
    },
    show404Modal(isShow) {
      this.showModal = isShow;
    },
    show500Modal(isShow) {
      this.showModal = isShow;
    },
    currentTab() {
      this.forceRerender()
    }
  },
  methods: {
    onTabChange(newTab) {
      console.log(newTab);
      this.currentTab = newTab;
    },
    onReady(newPlayerInstance) {
      newPlayerInstance.volume(this.previewOptions?.volume);
      window.player = newPlayerInstance;
    },
    forceRerender() {
      this.componentKey += 1;
    },
    onCloseModal() {
      this.isReadyToPreview = false;
    },
    previewNewConfig(newConfiguration) {
      // reduce object
      this.playerOptions = { ...newConfiguration };
      this.previewOptions = JSON.parse(JSON.stringify(newConfiguration));
      const defaultVal = JSON.parse(JSON.stringify(defaultOptions));
      for (const [k] of Object.entries(defaultVal)) {
        if (
          JSON.stringify(this.previewOptions[k]) ===
          JSON.stringify(defaultVal[k])
        ) {
          // console.log("Key ",k,this.previewOptions[k] ,"equal", defaultOptions[k])
          delete this.previewOptions[k];
        }
      }
      if (this.previewOptions.plugins?.bytearkAds?.adTagUrl === "") {
        delete this.previewOptions.plugins?.bytearkAds;
      }
      if (this.previewOptions.plugins?.bytearkFirework?.subscriberUrl === "") {
        delete this.previewOptions.plugins?.bytearkFirework;
      }
      if (this.previewOptions.plugins?.bytearkLighthouse?.projectId === "") {
        delete this.previewOptions.plugins?.bytearkLighthouse;
      }
      // this.previewOptions.errors = Object.entries(this.previewOptions.errors)
      //   .filter((ele) => ele[1].imageUrl != "" && ele[1].message != "")
      //   .reduce((accum, [k, v]) => {
      //     accum[k] = v;
      //     return accum;
      //   }, {});

      console.log("new option are", this.previewOptions);
      this.postToPreview();
    },
    onGenerateURL() {
      this.isReadyToGenerateURL = true;
      const query = this.$route.query;
      if (!query.config) {
        this.postForURL();
      } else {
        this.updateConfig(query.config);
      }
    },
    async postToPreview() {
      const url =
        "https://byteark-player-playground-develop-1.poring.arkcube.com/api/v1/preview";
      try {
        const res = await axios.post(url, this.previewOptions);
        const data = await res.data;
        // show success modal
        console.log(data);
        this.showSuccessModal = true;
        this.forceRerender();
      } catch (e) {
        // show fail modal
        switch (e.response.status) {
          case 404:
            this.show404Modal = true;
            console.error(e);
            break;
          case 500:
            this.show500Modal = true;
            console.error(e);
            break;
          case 422:
            this.showInvalidModal = true;
            console.log(e.response.data);
            this.errors = e.response.data.errors.map((ele) => ({
              field: ele.field,
              input: _.get(this.previewOptions, ele.field),
            }));
            break;
        }
      }
    },
    async postForURL() {
      const url =
        "https://byteark-player-playground-develop-1.poring.arkcube.com/api/v1/config";
      try {
        const res = await axios.post(url, this.previewOptions);
        const data = await res.data;
        console.log(data);
        this.playgroundUrl = `https://byteark-player-playground-develop-1.poring.arkcube.com/?config=${data.configId}`;
        console.log("url ", this.playgroundUrl);
      } catch (e) {
        console.err(e);
      }
    },
    async updateConfig(configId) {
      const url = `https://byteark-player-playground-develop-1.poring.arkcube.com/api/v1/config/${configId}`;
      try {
        const res = await axios.put(url, this.previewOptions);
        const data = await res.data;
        console.log(data);
        this.playgroundUrl = `https://byteark-player-playground-develop-1.poring.arkcube.com/?config=${data.configId}`;
      } catch (e) {
        console.err(e);
      }
    },
    async getConfig() {
      try {
        this.loading = true;
        const query = this.$route.query;
        if (!query.config) {
          console.log("using default config");
          this.playerOptions = {
            sources: {
              title: "Test Video",
              src: "https://devstreaming-cdn.apple.com/videos/streaming/examples/img_bipbop_adv_example_fmp4/master.m3u8",
              type: "application/x-mpegURL",
            },
          };
          this.previewOptions = { ...this.playerOptions };
        } else {
          const url = `https://byteark-player-playground-develop-1.poring.arkcube.com/api/v1/config/${query.config} `;
          const response = await axios.get(url);
          const data = response.data;
          this.loading = false;
          this.playerOptions = data;
          this.previewOptions = data;

          console.log(this.playerOptions);
          console.log(this.previewOptions);
          this.forceRerender();
        }
      } catch (e) {
        // this.error = true;
        // this.$router.push({ name: "NotFound" }, { path: "/404" });
        console.error(e);
      }
    },
  },
};
</script>

<style lang="scss">
@import "~@byteark/byteark-player-vue/dist/@byteark/byteark-player-vue.css";
@import "~@/assets/scss/button.scss";
@import "~@/assets/scss/container.scss";

header {
  margin: 0 0 $space + 8px 0;
  h1 {
    font-size: $base-font-size + 10px;
    font-weight: 700;
    color: $bg-navy;
  }
}
.stop-scrolling {
  height: 100%;
  overflow: hidden;
}
.scrolling {
  overflow-y: scroll;
}
.information {
  max-width: 720px;
  width: 100%;
  margin: 0 auto;
  padding: $space - 4px $space - 4px $space - 4px $space + 20px;
  background-color: rgba($color: $success, $alpha: 0.05);
  border: 1px solid rgba($color: $success, $alpha: 0.5);
  border-radius: $radius + 2px;
  color: $grey-1000;
  font-size: $base-font-size - 2px;
  line-height: 200%;
  position: relative;
  .check-icon {
    position: absolute;
    top: 13.55px;
    left: 13.28px;
  }
}

.invalid-information {
  @extend .information;
  background-color: rgba($color: $danger, $alpha: 0.05);
  border: 1px solid rgba($color: $danger, $alpha: 0.5);
}

.close-btn {
  background: none;
  color: $grey-800;
  text-decoration: underline;
  cursor: pointer;
}
.image-error {
  max-width: 450px;
  margin: 0 auto;
  margin-bottom: $space / 2;
  svg {
    width: 100%;
    height: 100%;
  }
}
.information-error {
  text-align: center;
  margin: 0 auto;
  .title {
    font-size: $base-font-size + 14px;
    font-weight: 700;
    margin-bottom: $space + 8px;
  }
  .detail {
    font-size: $base-font-size + 4px;
    font-weight: 400;
    color: $grey-800;
    a {
      color: $ci-primary;
      text-decoration: underline;
    }
  }
}
.invalid-fields {
  border-spacing: 0;
  max-width: 720px;
  margin: 0 auto;
  text-align: left;
  table-layout: fixed;
  width: 100%;
  tr:nth-child(odd) {
    background-color: $grey-300;
  }
  tr:nth-child(even) {
    background-color: $grey-100;
  }
  th {
    padding: $space / 2 $space;
    font-size: $base-font-size - 2px;
    font-weight: 700;
    color: $grey-800;
    border: 0;
  }
  td {
    padding: $space;

    font-size: $base-font-size;
    line-height: 140%;
    &.name {
      color: $grey-1000;
      font-weight: 700;
    }
    &.input {
      color: $grey-800;
      font-weight: 400;
    }
  }
}
.w-720 {
  width: 720px;
}
</style>
